import { render } from "./adminTable.vue?vue&type=template&id=06e3fd4c"
import script from "./adminTable.vue?vue&type=script&lang=js"
export * from "./adminTable.vue?vue&type=script&lang=js"

import "./adminTable.vue?vue&type=style&index=0&id=06e3fd4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__